<template>
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
      Edit Details
      <v-spacer> </v-spacer>
      <v-spacer> </v-spacer>
      <v-btn depressed  @click="$emit('closeDialog')" fab x-small icon
        ><v-icon>mdi-close</v-icon></v-btn
      >
    </v-card-title>

    <v-card-text class="mt-4">
      <v-form v-model="valid" ref="form">
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">First Name </label>
            <v-text-field
              :rules="first_nameRules"
              class="rounded"
              v-model="sender_data.first_name"
              dense
              outlined
              placeholder="First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Middle Name </label>
            <v-text-field
              class="rounded"
              v-model="sender_data.middle_name"
              :rules="middle_nameRules"
              dense
              outlined
              placeholder="Middle Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Last Name</label>
            <v-text-field
              class="rounded"
              v-model="sender_data.last_name"
              :rules="last_nameRules"
              dense
              outlined
              placeholder="Last Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Address</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="sender_data.address"
              :rules="addressRule"
              placeholder="Address"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Id type</label>
            <v-autocomplete
              v-model="sender_data.id_type"
              :items="dropdown.idTypeOptions"
              :rules="idtypeRules"
              placeholder="Select Your ID Type"
              dense
              class="rounded"
              outlined
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Id number</label>
            <v-text-field
              v-model="sender_data.id_number"
              placeholder="Enter Your ID Number"
              dense
              outlined
              class="rounded"
              required
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Issue Date</label>
            <v-text-field
              class="rounded"
              :rules="[issueRules]"
              dense
              v-model="sender_data.issue_date"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Expiry Date</label>
            <v-text-field
              class="rounded"
              :rules="[ExpiryDateRules]"
              dense
              v-model="sender_data.expire_date"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Issue Counrty</label>
            <v-autocomplete
              dense
              outlined
              placeholder="Issue Counrty"
              class="rounded"
              item-text="text"
              item-value="value"
              :items="dropdown.countryOptions"
              v-model="sender_data.issue_country"
            ></v-autocomplete>
          </v-col> -->
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Email Id</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="sender_data.email"
              :rules="emailRules"
              placeholder="Email Id"
            ></v-text-field>
          </v-col> -->
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Mobile Number</label>
            <v-text-field
              placeholder="Enter Mobile Number"
              dense
              class="rounded"
              outlined
              v-model="sender_data.mobile"
              :rules="contactNumbrules"
              prefix="+60"
              required
              type="number"
              hide-spin-buttons
              :hint="'+60 xx xxx xxxx'"
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">DOB</label>
            <v-text-field
              :min="minDate"
              :max="maxDate"
              :rules="[DOBRules]"
              class="rounded"
              dense
              v-model="sender_data.dob"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Gender</label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="sender_data.gender"
              :items="dropdown.genderOptins"
              :rules="genderRules"
              outlined
              placeholder="Gender"
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Nationality</label>
            <v-autocomplete
              class="rounded"
              v-model="sender_data.nationality"
              :rules="nationalityRules"
              item-text="text"
              item-value="value"
              :items="dropdown.nationalityList"
              dense
              outlined
              placeholder="Nationality"
            ></v-autocomplete>
          </v-col> -->
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">occupation</label>
            <v-autocomplete
              class="rounded"
              dense
              outlined
              v-model="sender_data.occupation"
              item-text="text"
              item-value="value"
              :items="dropdown.occupation_list"
              :rules="occupationRules"
              placeholder="Occupation"
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Employer</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="sender_data.employer"
              :rules="employerRules"
              placeholder="Employer"
            ></v-text-field>
          </v-col> -->
          <!-- <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0">Purpose of remittance</label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="sender_data.source_of_funds"
              item-text="text"
              item-value="value"
              :items="dropdown.purposeofRemi_list"
              outlined
              :rules="sourceofFundRules"
              placeholder="Purpose of remittance"
            ></v-autocomplete>
          </v-col> -->
          <v-col cols="12" md="6" sm="6">
            <label class="labelFontsize my-0 required">Source Of Income</label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="sender_data.source_of_funds"
              item-text="text"
              item-value="value"
              :items="dropdown.sourceofFunds_list"
              outlined
              :rules="sourceofFundRules"
              placeholder="Source Of Income"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed  color="primary" outlined @click="$emit('closeDialog')">
        <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
      </v-btn>
      <v-btn depressed  color="primary" @click="updateSenderInfo()"> Update </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { validation } from "@/utils/validationCopy.js";
import { findDatePrevious } from "@/utils/helper";
import alerts from "@/mixins/alerts";
import PaymentService from "@/services/PaymentService/paymentService.js";
import commonService from "@/services/CommonService/commonService.js";
export default {
  name: "senderInfoEdit",
  mixins: [alerts],
  data() {
    return {
      ...validation,
      maxDate: "",
      minDate: "",
      valid: false,
      editSenderDialog: false,
      issueDate: false,
      expDate: false,
      transaction_id: null,
      dropdown: {
        genderOptins: [
          {
            text: "Male",
            value: "M",
          },
          {
            text: "Female",
            value: "F",
          },
        ],
        nationalityList: [],
        occupation_list: [],
        sourceofFunds_list: [],
        purposeofRemi_list: [],
        id_list: [],
        countryOptions: [],
        idTypeOptions: [],
      },
      sender_data: {
        first_name: "",
        middle_name: "",
        last_name: "",
        partner_customer_id: null,
        user_id: "",
        customer_id: null,
        address: "",
        id_type: null,
        id_number: "",
        expire_date: "",
        issue_date: "",
        issue_country: "",
        email: "",
        dob: null,
        occupation: null,
        mobile: "",
        phone_number: "",
        employer: "",
        gender: "",
        nationality: null,
        source_of_funds: null,
        kyc: "",
        user_type: "",
      },
    };
  },
  props: {
    senderInfo: {
      type: Object,
    },
  },
  mounted() {
    this.getnationality();
    this.getSourceOfFunds();
    this.getOccupation();
    this.getcountryList();
    this.getIdList();
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
    this.mapsenderData();
    this.transaction_id = this.$route.query.payment_id
      ? this.$route.query.payment_id
      : null;
  },
  watch: {},
  methods: {
    issueRules(value) {
      if (!value) {
        return 'Issue date is required';
      }
      if (value > new Date().toISOString().substr(0, 10)) {
        return "Issue date cannot be in the future";
      }
      if (value && this.sender_data.expire_date) {
        return (
          value <= this.sender_data.expire_date ||
          "Issue date cannot be later than Expiry date"
        );
      }
      return true; // Validation passed
    },
    ExpiryDateRules(value) {
      if (!value) {
        return 'Expiry date is required';
      }
      // if (value > new Date().toISOString().substr(0, 10)) {
      //   return "Expiry date cannot be in the future";
      // }
      if (value && this.sender_data.issue_date) {
        return (
          value >= this.sender_data.issue_date ||
          "Expiry date cannot be earlier than Issue date"
        );
      }
      return true; // Validation passed
    },
    DOBRules(value) {
      if (!value) {
        return 'Date of Birth is required';
      }
      if(value && !(value <= this.maxDate )){
        return 'Age should above 18'
      }
      return true; // Validation passed
    },
    mapsenderData() {
      const val = this.senderInfo;
      this.sender_data = {
        first_name: val.first_name,
        middle_name: val.middle_name,
        last_name: val.last_name,
        partner_customer_id: val.partner_customer_id,
        user_id: val.user_id,
        customer_id: val.customer_id,
        address: val.address,
        id_type: val.id_type ? val.id_type.value_code : null,
        id_number: val.id_number,
        expire_date: val.expire_date ? val.expire_date : null,
        issue_date: val.issue_date ? val.issue_date : null,
        issue_country: val.issue_country,
        email: val.email,
        dob: val.dob ? val.dob : null,
        occupation: val.occupation ? val.occupation.value_code : null,
        mobile: val.mobile,
        phone_number: val.phone_number,
        employer: val.employer,
        gender: val.gender,
        nationality: val.nationality ? val.nationality.iso_alpha3 : null,
        source_of_funds: val.source_of_funds
          ? val.source_of_funds.value_code
          : null,
        kyc: val.kyc,
        user_type: val.user_type,
      };
    },
    async updateSenderInfo() {
      const validate = this.$refs.form.validate();
            if (validate) {
        try {
          const responseData = await PaymentService.updateSender(
            this.sender_data.customer_id,
            this.sender_data
          );
          if (responseData && responseData.data.status_code === 200) {
            this.versionUpdate(responseData.data.data[0].customer_version_id);
            this.showAlertSuccess(responseData.data.message);
          } 
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.profileupdateindivi();
          // } 
          else {
            this.showAlertError(`Failed: ${responseData.data.message}`);
          }
          console.log("sender", responseData);
        } catch (e) {
          console.error(e);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
      // this.closeStatus();
    },
    async versionUpdate(id) {
      try {
        const responseData = await PaymentService.updateTxnUpdateVersion({
          transaction_id: this.transaction_id,
          customer_version_id: id,
        });
        if (responseData && responseData.data.status_code === 200) {
          this.$emit("closeDialog");
          this.$emit("DataUpdated");
          // this.showAlertSuccess(responseData.data.message);
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.profileupdateindivi();
        // }
         else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Something went wrong.`);
      }
    },
    async getIdList() {
      this.loader = true;
      const code = "DOC";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code === 200) {
          this.dropdown.idTypeOptions = responseData.data.data.map((i) => {
            return {
              text: i.value,
              value: i.value_code,
            };
          });
          this.loader = false;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getIdList();
        // }
         else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("idList", responseData);
      } catch (e) {
        this.loader = false;
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
    async getcountryList() {
      try {
        const responseData = await commonService.getdropdowns();
        if (responseData && responseData.data.status_code === 200) {
          this.dropdown.countryOptions = responseData.data.data.map((i) => {
            return {
              text: i.country_name,
              value: i.value_code,
            };
          });
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getcountryList();
        // }
         else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getnationality() {
      try {
        const responseData = await commonService.getdropdowns();
        if (responseData && responseData.data.status_code === 200) {
          this.dropdown.nationalityList = responseData.data.data.map((i) => {
            return {
              text: i.nationality,
              value: i.iso_alpha3,
            };
          });
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getnational();
        // }
         else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("nationality", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getSourceOfFunds() {
      const code = "SOF";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code === 200) {
          this.dropdown.sourceofFunds_list = responseData.data.data.map((i) => {
            return {
              text: i.value,
              value: i.value_code,
            };
          });
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getSourceOfFunds();
        // } 
        else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getOccupation() {
      const code = "OCC";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData && responseData.data.status_code === 200) {
          this.dropdown.occupation_list = responseData.data.data.map((i) => {
            return {
              text: i.value,
              value: i.value_code,
            };
          });
        } 
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getOccupation();
        // }
         else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        console.log("occupation", responseData);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}
</style>
